import { render, staticRenderFns } from "./AxNavigationLinkPrototype.vue?vue&type=template&id=24036fc2&"
import script from "./AxNavigationLinkPrototype.vue?vue&type=script&lang=ts&"
export * from "./AxNavigationLinkPrototype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports